export default payload => (dispatch) => {
  dispatch({ type: "APP/HTML/UPDATE", payload });
};
